// extracted by mini-css-extract-plugin
export default {"block":"BlueGradientBlock_block__6h7B3","bg":"BlueGradientBlock_bg__dtl8v"};